import { render } from "./Assignments.vue?vue&type=template&id=50b732a8"
import script from "./Assignments.vue?vue&type=script&lang=js"
export * from "./Assignments.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projects/enwan/enwan-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__